/**
 * @generated SignedSource<<8fd74dab36328fbbc4f776264631f587>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeaturedDealDirectoryQuery$variables = {};
export type FeaturedDealDirectoryQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FeaturedDealDirectoryRows_availableFeaturedDeals">;
};
export type FeaturedDealDirectoryQuery = {
  response: FeaturedDealDirectoryQuery$data;
  variables: FeaturedDealDirectoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  {
    "kind": "Literal",
    "name": "onlyWatching",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "-date"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "current",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentChange",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  (v1/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "releaseType",
    "storageKey": null
  },
  (v1/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedDealDirectoryQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "FeaturedDealDirectoryRows_availableFeaturedDeals"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FeaturedDealDirectoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "FeaturedDealNodeConnection",
        "kind": "LinkedField",
        "name": "availableFeaturedDeals",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeaturedDealNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FeaturedDealNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "watching",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "editorialNote",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TikTokSoundNodeConnection",
                    "kind": "LinkedField",
                    "name": "tiktokSounds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TikTokSoundNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TikTokSoundNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tiktokUrl",
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StatWithDelta",
                                "kind": "LinkedField",
                                "name": "mostRecentStat",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "previous",
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArtistNode",
                    "kind": "LinkedField",
                    "name": "artist",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ActorInterface",
                        "abstractKey": "__isActorInterface"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatWithDelta",
                        "kind": "LinkedField",
                        "name": "latestSpotifyMonthlyListenerCount",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isWatchingCurrentUserCompany",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNode",
                        "kind": "LinkedField",
                        "name": "spotifyProfile",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatWithDelta",
                        "kind": "LinkedField",
                        "name": "latestTiktokFollowerCount",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNode",
                        "kind": "LinkedField",
                        "name": "tiktokProfile",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastApprovedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "soundLink",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReleaseNodeConnection",
                        "kind": "LinkedField",
                        "name": "releases",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReleaseNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReleaseNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnreleasedReleaseNodeConnection",
                        "kind": "LinkedField",
                        "name": "unreleasedReleases",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnreleasedReleaseNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UnreleasedReleaseNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArtistNode",
                        "kind": "LinkedField",
                        "name": "artist",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserNode",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastActiveAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "actor",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v9/*: any*/),
                                      (v1/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProfileNode",
                                            "kind": "LinkedField",
                                            "name": "spotifyProfile",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "ArtistNode",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ActorInterface",
                            "abstractKey": "__isActorInterface"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "OfferFeaturedDealInterface",
                    "abstractKey": "__isOfferFeaturedDealInterface"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "availableFeaturedDeals(first:25,onlyWatching:false,orderBy:\"-date\")"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "filters": [
          "orderBy",
          "onlyWatching",
          "genres",
          "releasesCount",
          "streamsThisWeek",
          "spotifyMonthlyListeners",
          "tiktokPosts",
          "tiktokFollowers"
        ],
        "handle": "connection",
        "key": "FeaturedDealDirectory_availableFeaturedDeals",
        "kind": "LinkedHandle",
        "name": "availableFeaturedDeals"
      }
    ]
  },
  "params": {
    "cacheID": "71357e3905c67102ec8aed9e502d2715",
    "id": null,
    "metadata": {},
    "name": "FeaturedDealDirectoryQuery",
    "operationKind": "query",
    "text": "query FeaturedDealDirectoryQuery {\n  ...FeaturedDealDirectoryRows_availableFeaturedDeals\n}\n\nfragment AvatarIcon_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    lastActiveAt\n    ...useUserThumbnailUrl_user\n    id\n  }\n}\n\nfragment FeaturedDealDirectoryRows_availableFeaturedDeals on Query {\n  availableFeaturedDeals(first: 25, orderBy: \"-date\", onlyWatching: false) {\n    edges {\n      node {\n        id\n        ...RowDeal_featuredDeal\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment OfferDealArtistReleases_query on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  artist {\n    displayName\n    isWatchingCurrentUserCompany\n    ...AvatarIcon_actor\n    id\n  }\n  ...useFeaturedDealTitle\n}\n\nfragment RowDeal_dropdown on FeaturedDealNode {\n  id\n  watching\n  editorialNote\n  tiktokSounds {\n    ...RowDeal_useTikTokSoundsTotal\n  }\n  artist {\n    ...useMessage_actor\n    displayName\n    latestSpotifyMonthlyListenerCount {\n      current\n      percentChange\n    }\n    id\n  }\n  ...useFeaturedDealTitle\n}\n\nfragment RowDeal_featuredDeal on FeaturedDealNode {\n  ...RowDeal_dropdown\n  ...OfferDealArtistReleases_query\n  id\n  artist {\n    id\n    displayName\n    latestSpotifyMonthlyListenerCount {\n      current\n      percentChange\n    }\n    isWatchingCurrentUserCompany\n    spotifyProfile {\n      url\n      id\n    }\n    latestTiktokFollowerCount {\n      current\n      percentChange\n    }\n    tiktokProfile {\n      url\n      id\n    }\n  }\n  lastApprovedAt\n  watching\n  soundLink\n  editorialNote\n  tiktokSounds {\n    ...RowDeal_useTikTokSoundsTotal\n  }\n}\n\nfragment RowDeal_useTikTokSoundsTotal on TikTokSoundNodeConnection {\n  edges {\n    node {\n      tiktokUrl\n      name\n      mostRecentStat {\n        current\n        previous\n        percentChange\n      }\n      id\n    }\n  }\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useFeaturedDealTitle on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n}\n\nfragment useMessage_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    ...useMessage_user\n    id\n  }\n}\n\nfragment useMessage_user on UserNode {\n  id\n}\n\nfragment useUserThumbnailUrl_user on UserNode {\n  actor {\n    __typename\n    thumbnailUrl\n    ...useArtistThumbnailUrl_artist\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "16726f84d3e8771d48f3c8df1140c47f";

export default node;
